import { createContext, useContext } from 'react'

import { CatalogProductsData, FilterData, SeoLink, StepFilterProperty } from '@/entities/catalog-old'

export type CatalogSeoLinks = {
	RELATED_LINK_TOP: SeoLink[]
	RELATED_LINK_BOTTOM: SeoLink[]
}

type CatalogInitialData = {
	initialFilterData: FilterData | null
	initialProductsData: CatalogProductsData | null
	initialSeoLinks: CatalogSeoLinks | null
	initialStepFilterData: StepFilterProperty[] | null
	initialResolvedUrl: string
}

const CatalogInitialDataContext = createContext<CatalogInitialData>({
	initialFilterData: null,
	initialProductsData: null,
	initialSeoLinks: null,
	initialStepFilterData: null,
	initialResolvedUrl: ''
})

export const CatalogInitialDataProvider = CatalogInitialDataContext.Provider
export const useCatalogInitialData = () => useContext(CatalogInitialDataContext)
